import { styled } from '@mui/material/styles';

export const Editor = styled('section')`
  margin: 16px 0;
  padding: 14px;
  border: 1px solid #dce3f0;
  border-radius: 8px;
  color: #10213f;
  font-size: var(--v3-body-size, 14px);
  line-height: 1.45;
  label {
    display: block;
    margin-bottom: 8px;
    font-weight: 700;
  }
  .form-row {
    display: flex;
    gap: 8px;
  }
  input {
    min-width: 0;
    width: 100%;
    padding: 10px 12px;
    border: 1px solid #9aa8c0;
    border-radius: 7px;
    font: inherit;
    letter-spacing: 2px;
  }
  button {
    padding: 8px 12px;
    flex-shrink: 0;
    font: inherit;
  }
  input:focus-visible {
    outline: 3px solid rgba(63, 86, 226, 0.22);
  }
  p {
    margin: 8px 0 0;
    color: #65728a;
  }
  .result {
    color: #007d63;
  }
  @media (max-width: 370px) {
    .form-row {
      flex-direction: column;
    }
  }
`;
export const Error = styled('p')`
  padding: 12px;
  border: 1px solid #f3b4b4;
  border-radius: 8px;
  background: #fff4f4;
  color: #a72121 !important;
  font-size: var(--v3-body-size, 14px);
  line-height: 1.45;
`;
export const Notice = styled('p', {
  shouldForwardProp: (prop) => prop !== 'verified',
})<{ verified?: boolean }>`
  padding: 12px;
  border: 1px solid ${({ verified }) => (verified ? '#75e2b7' : '#ffd487')};
  border-radius: 8px;
  background: ${({ verified }) => (verified ? '#ecfff6' : '#fff9ec')};
  color: ${({ verified }) => (verified ? '#007d63' : '#805500')};
  font-size: var(--v3-body-size, 14px);
  line-height: 1.45;
`;
